import useAuthStore from '@oncolens/oncolens-ui/lib/stores/AuthStore';
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useConferenceManagement } from '@/hooks/featureFlags/active-flags/useConferenceManagement';
import { Outlet } from 'react-router-dom';
import shallow from 'zustand/shallow';
import { LoadingComponent } from '..';

export const MainContainer = () => {
  const conferenceMangementFlag = useConferenceManagement();
  const [domainUser, hasRole] = useAuthStore((x) => [x.domainUser, x.hasRole], shallow);
  return (
    <main
      className={`w-full h-full p-5 shadow-inner ${
        conferenceMangementFlag ? 'bg-zinc-200' : 'bg-gradient-to-br from-gray-100 to-gray-200'
      }`}>
      {domainUser && hasRole('Chancellor') ? <Outlet /> : <LoadingComponent />}
    </main>
  );
};
